// src/pages/ContactPage.js
import React from "react";
import { BlogSection } from "../components/blog-section";


export const BlogPage = ({ data }) => {
  return (
    <div className="standalone-page">
      <BlogSection data={data} />
    </div>
  );
};